
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja/perencanaan",
      function () {
        return require("private-next-pages/pengelolaan-kinerja/perencanaan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja/perencanaan"])
      });
    }
  